(function() {
  "use strict";

  angular.module("PrintQueuePropertiesMulti")

    .controller("PrintQueuePropertiesMultiController", [
      "$scope", "$filter", "$location", "URLS", "PrintQueueListService", "toastr",
      "$routeParams", "URL_PARAMS", "$q", "$window", "TenantListService", 'EventHandlerService',
      'currentTenant', '$rootScope', '$timeout',
      function(
        $scope, $filter, $location, URLS, PrintQueueListService, toastr,
        $routeParams, URL_PARAMS, $q, $window, TenantListService, EventHandlerService,
        currentTenant, $rootScope, $timeout) {


        $scope.printQueueSettingsModel = {
          active: false,
          autoInstall: false,
          autoRemove: false,
          ignoreSecurePrint: false,
          alwaysReprint: false,
          mobilePrint: false,
          defaultMono: false,
          defaultDuplex: false,
          publishUp: false,
          viaTheCloud: false,
          global: false,
          releaseFromOtherNetworksEnabled: false,
        };

        $scope.printQueueSettingsModelCopyPristine = angular.copy($scope.printQueueSettingsModel);
        for (const key in $scope.printQueueSettingsModelCopyPristine) {
          $scope.printQueueSettingsModelCopyPristine[key] = true;
        }

        $scope.middleStage = {
          active: false,
          autoInstall: false,
          autoRemove: false,
          ignoreSecurePrint: false,
          alwaysReprint: false,
          mobilePrint: false,
          defaultMono: false,
          defaultDuplex: false,
          publishUp: false,
          viaTheCloud: false,
          global: false,
          releaseFromOtherNetworksEnabled: false,
        };

        $scope.allPrintQueuesViaTheCloud = {
          setting: 'middleStage'
        };

        const attributes = [
          {info: 'active'},
          {info: 'autoInstall'},
          {info: 'autoRemove'},
          {info: 'alwaysReprint'},
          {info: 'ignoreSecurePrint'},
          {info: 'mobilePrint'},
          {info: 'defaultMono'},
          {info: 'defaultDuplex'},
          {info: 'publishUp'},
          {info: 'global'},
          {info: 'releaseFromOtherNetworksEnabled'},
          {globalPrinting: 'viaTheCloud'}
        ];

        $scope.printQueues = null;
        $scope.printQueuesOriginal = null;
        $scope.urls = URLS;
        $scope.tenantListService = TenantListService;
        $scope.printQueuesPropertiesMulti = {};
        $scope.printQueuesUpdated = 0;
        $scope.criticalDataReady = false;
        $scope.hasAnywhereQueue = false;
        $scope.hasPrintQueues = false;
        $scope.eventHandlerService = EventHandlerService;
        $scope.me = null;
        $scope.suppressSaveButton = true;
        $scope.helpCaption = 'HelpPrintQueuesMultiEdit'
        $scope.universalPrintEnabled = false;
        $scope.isPrintQueueSiblings = false;
        $scope.anywhereQueues = [];
        let originPage = null;

        $scope.loadingPage = true;
        $scope.noDataMessage = 'NoSearchResultQueue';
        $scope.windowWidth = $window.innerWidth;


        (function (){
          checkUniversalPrintEnabled();
        })();

        function checkUniversalPrintEnabled () {
          if (currentTenant.info._embedded.tenantIdentityProviders.providers.azure) {
            const azureDirectories = currentTenant.info._embedded.tenantIdentityProviders.providers.azure.directories;
            for (const key in azureDirectories) {
              if (azureDirectories[key].universal_print_enabled) {
                $scope.universalPrintEnabled = true;
                break
              }
            }
          }
        };

        $scope.$watch(function() {
          return $rootScope.currentUser
        }, function() {
          if ($rootScope.currentUser) {
            $scope.me = $rootScope.currentUser;
            initEventHandler();
            initMultiEdit();
          }
        });

        function initEventHandler() {
          $scope.eventHandlerService.deRegisterListeners();
        };

        $scope.updateModel = function (attribute) {

          $scope.printQueueSettingsModelCopyPristine[attribute] = false;

          switch (attribute) {
            case 'active':
            case 'autoInstall':
            case 'autoRemove':
            case 'ignoreSecurePrint':
            case 'alwaysReprint':
            case 'mobilePrint':
            case 'defaultMono':
            case 'defaultDuplex':
            case 'publishUp':
              $scope.middleStage[attribute] = false;
            break;
            case 'viaTheCloud':
              $scope.middleStage[attribute] = false;
              if (!$scope.printQueueSettingsModel.viaTheCloud) {
                $scope.allPrintQueuesViaTheCloud.setting = 'middleStage';
                $scope.printQueueSettingsModel.global = false;
                $scope.printQueueSettingsModel.releaseFromOtherNetworksEnabled = false;
              } else {
                if ($scope.printQueueSettingsModel.autoRemove || $scope.middleStage.autoRemove || !$scope.me.permissions.TENANT_ADMIN) {
                  $scope.allPrintQueuesViaTheCloud.setting = 'RELEASE_FROM_OTHER_NETWORKS_ENABLED';
                  $scope.printQueueSettingsModel.global = false;
                  $scope.printQueueSettingsModel.releaseFromOtherNetworksEnabled = true;
                } else {
                  $scope.allPrintQueuesViaTheCloud.setting = 'GLOBAL';
                  $scope.printQueueSettingsModel.global = true;
                  $scope.printQueueSettingsModel.releaseFromOtherNetworksEnabled = false;
                }
              }
            break;
            case 'global':
              $scope.printQueueSettingsModel.global = true;
              $scope.printQueueSettingsModel.releaseFromOtherNetworksEnabled = false;
              $scope.printQueueSettingsModel.viaTheCloud = true;
              $scope.middleStage.viaTheCloud = false;
              $scope.printQueueSettingsModelCopyPristine.viaTheCloud = false;
            break;
            case 'releaseFromOtherNetworksEnabled':
              $scope.printQueueSettingsModel.global = false;
              $scope.printQueueSettingsModel.releaseFromOtherNetworksEnabled = true;
              $scope.printQueueSettingsModel.viaTheCloud = true;
              $scope.middleStage.viaTheCloud = false;
              $scope.printQueueSettingsModelCopyPristine.viaTheCloud = false;
            break;
          }
        };

        $scope.handlePrintQueueNetworks = function (event, context, menuOption) {
          $scope.suppressSaveButton = true;
          $scope.printQueuesPropertiesMulti.$dirty = true;
          $timeout(function  () {
            if (event, context, menuOption) {
              $scope.selectedContextMenuItem  =  menuOption;
              $scope.context = context;
              $scope.context.printQueues = $scope.printQueues;
            }
          }, 50)
        }


        $scope.saveChanges = function (form, event, context, menuOption){
          $scope.suppressSaveButton = true;
          $timeout(function  () {
            if (event, context, menuOption) {
              $scope.selectedContextMenuItem  =  menuOption;
              $scope.contextPosition =  { left: event.clientX, top: event.clientY };
              $scope.context = context;
              $scope.context.form = form;
              $scope.context.mappedNetworks = $scope.mappedNetworks || null;

              $scope.context.printQueues = $scope.printQueues;
              $scope.context.printQueuesOriginal = $scope.printQueuesOriginal;
              $scope.context.printQueueSettingsModel = $scope.printQueueSettingsModel;
              $scope.context.middleStage = $scope.middleStage;
              $scope.context.originPage = originPage;
            }
          }, 50)
        };

        $scope.closeAllMenues = function (newContext) {
          $scope.suppressSaveButton = false;
          if (newContext) {
            // openNewContext(newContext)
          } else {
            $scope.selectedContextMenuItem  =  null;
            $scope.contextPosition = null;
            $scope.context = null;
          }
        }

        $scope.checkForAnywhereQueue = function() {
          $scope.hasAnywhereQueue = $scope.printQueuesOriginal.some((printQueue) => {
            return !isNaN(printQueue.info.signId);
          })

          $scope.hasPrintQueues = $scope.printQueuesOriginal.some((printQueue) => {
            return isNaN(printQueue.info.signId);
          })
        };

        $scope.removePrintQueue = function (printQueue) {
          const printQueueId = printQueue.info._links.self.href;
          $scope.printQueuesOriginal = $scope.printQueuesOriginal.filter(printQueuOriginal => printQueuOriginal.info._links.self.href !== printQueueId);
          $scope.printQueues = angular.copy($scope.printQueuesOriginal);
          const printQueueIdsArray = $scope.printQueuesOriginal.map(printQueueOriginal => `${printQueueOriginal.printerId}:${printQueueOriginal.customProperties.id}`);
          let url = URLS.PRINT_QUEUE_PROPERTIES_MULTI.replace(URL_PARAMS.PRINT_QUEUE_URL.LOCATION, printQueueIdsArray);

          if ($scope.printQueuesPropertiesMulti.$dirty === true) {
            $scope.printQueuesPropertiesMulti.$setPristine();
            $location.path(url, false).replace();
          } else {
            $location.path(url, false).replace();
          }

          $scope.checkForAnywhereQueue();
          checkPrintQueueSiblings();
          calibrateMultiEditTemplate();

        };


        function calibrateMultiEditTemplate() {
          if ($scope.printQueues.length > 0) {

            for (const key in $scope.printQueueSettingsModel) {
              $scope.printQueueSettingsModelCopyPristine[key] = true;
              $scope.printQueueSettingsModel[key] = false;
              $scope.middleStage[key] = false;
            }

            let isTrue = (item) => item === true;
            let isFalse = (item) => item === false;

            const allPrintQueueAttrState = (originalPrintQueues, path, attr, predicate) => { // Predicate is a naming convention of a function that returns either true or false
              return originalPrintQueues.map((printQueue) => {
                return printQueue[path][attr]
              }).every((predicate));
            }

            const excludeAnywherePrintQueues = ((originalPrintQueues) => {
              return originalPrintQueues.filter((printQueue) => {
                return isNaN(printQueue.info.signId);
              })
            })($scope.printQueuesOriginal);

            attributes.forEach((attribute) => {
              for (const key in attribute) {
                if (allPrintQueueAttrState($scope.printQueuesOriginal, key, attribute[key], isTrue)) {
                  $scope.printQueueSettingsModel[attribute[key]] = true;
                } else if (allPrintQueueAttrState($scope.printQueuesOriginal, key, attribute[key], isFalse)) {
                  $scope.printQueueSettingsModel[attribute[key]] = false;
                } else {
                  $scope.middleStage[attribute[key]] = true;
                }
              }
            })

            $scope.networkCommonSetCount = excludeAnywherePrintQueues.flatMap((queue) => {
              const releaseFromOtherNetwork = queue.info._links['px:releaseFromOtherNetwork'];
              if (releaseFromOtherNetwork) {
                if (Array.isArray(releaseFromOtherNetwork)) {
                  return releaseFromOtherNetwork.map(network => network.href)
                } else if  (!Array.isArray(releaseFromOtherNetwork)) {
                  return releaseFromOtherNetwork.href;
                }
              }
            }).reduce(
              (unique, item) => (unique.includes(item) ? unique : [...unique, item]),
              [],
            ).filter(function (element) {
              return element != null;
            });

            $scope.mappedNetworks = {
              addSelectedNetworks: $scope.networkCommonSetCount,
              removeSelectedNetworks: [],
              selectedNetworksOriginal: $scope.networkCommonSetCount,
            }

            if ($scope.printQueueSettingsModel.viaTheCloud) {
              if (allPrintQueueAttrState(excludeAnywherePrintQueues, 'info', 'global', isTrue)) {
                $scope.allPrintQueuesViaTheCloud.setting = 'GLOBAL';
                $scope.printQueueSettingsModel.global = true;
              } else if (allPrintQueueAttrState(excludeAnywherePrintQueues, 'info', 'releaseFromOtherNetworksEnabled', isTrue)) {
                $scope.allPrintQueuesViaTheCloud.setting = 'RELEASE_FROM_OTHER_NETWORKS_ENABLED';
                $scope.printQueueSettingsModel.releaseFromOtherNetworksEnabled = true;
              } else {
                $scope.allPrintQueuesViaTheCloud.setting = 'middleStage';
              }
            }

          } else {
            $location.path(URLS.PRINT_QUEUE_LIST);
          }
        }

        function loadPrintQueue (urlList, deferred, listToReturn) {
          if (urlList.length > 0) {
            var url = currentTenant.info._links['px:printers'].href +'/'+ urlList.pop();
            PrintQueueListService.getPrintQueueByURL(url).then(function(printQueue) {
              printQueue = mapGlobalPrinting(printQueue);
              listToReturn.push(printQueue);
              loadPrintQueue(urlList, deferred, listToReturn)
            }).catch(function(error) {});
          } else {
            deferred.resolve(listToReturn)
          }
        };

        function mapGlobalPrinting (printQueue) {
          var globalPrinting = {
            global: printQueue.info.global,
            releaseFromOtherNetworksEnabled: printQueue.info.releaseFromOtherNetworksEnabled,
            viaTheCloud: printQueue.info.global || printQueue.info.releaseFromOtherNetworksEnabled ? true : false,
          }
          if (globalPrinting.viaTheCloud) {
            globalPrinting.printSetting = printQueue.info.global ? 'GLOBAL' : 'RELEASE_FROM_OTHER_NETWORKS_ENABLED'
          }
          printQueue.globalPrinting = globalPrinting;
          return printQueue;
        };

        function checkPrintQueueSiblings () {

          const printerIds = $scope.printQueuesOriginal.map((printQueue) =>  printQueue.info._links['px:printer'].href);
          const hasSibling = printerIds.some((item, idx) => {
            return printerIds.indexOf(item) !== idx
          });

          if (hasSibling) {
            $scope.isPrintQueueSiblings = true;
          } else {
            $scope.isPrintQueueSiblings = false;
          }
        };

        function initMultiEdit() {
          if ($routeParams[URL_PARAMS.PRINT_QUEUE_URL.ROUTE]) {
            var printQueuePrinterPairs = $location.path().split('/printQueuePropertiesMulti/')[1].split(',');
            var printQueueLinkList = printQueuePrinterPairs.map((pair) => {
              return `${pair.split(':')[0]}/queues/${pair.split(':')[1]}`
            })
            originPage = $routeParams['printQueuePage'];
            var deferred = $q.defer();
            $scope.suppressSaveButton = true;
            loadPrintQueue(printQueueLinkList, deferred, []);

            deferred.promise.then(function(printQueueList) {
              $scope.suppressSaveButton = false;
              $scope.loadingPage = false;
              printQueueList = sortPrintQueues(printQueueList)
              $scope.printQueuesOriginal = printQueueList;
              $scope.printQueues = angular.copy(printQueueList);
              $scope.checkForAnywhereQueue();
              checkPrintQueueSiblings(printQueueList);
              calibrateMultiEditTemplate();
            }).catch(function(error) {
              $location.path(URLS.PRINT_QUEUE_LIST);
            });
          } else {
            $location.path(URLS.PRINT_QUEUE_LIST);
          }
        };

        function sortPrintQueues(printQueueList) {
          printQueueList.sort(function(a, b) {
            var a = a.info.signId.toLowerCase();
            var b = b.info.signId.toLowerCase();
            if (a < b) return -1;
            if (a > b) return 1;
            return 0;
          })
          return printQueueList;
        }


        ////////////////////////////////////////////
        ////////////////////////////////////////////
        // TOOLTIP STUFF
        ////////////////////////////////////////////
        $scope.showTooltip = function (showTip, position, tooltipScope, context) {
          if (showTip) {
            switch(tooltipScope) {
              case 'site':
                siteTooltip(position, context);
              break;
              case 'queue':
                queueTooltip(position, context);
              break;
            }
          } else {
            $scope.clearTooltip();
          }
        }

        function siteTooltip (position, title) {

          $scope.clearTooltip();
          $scope.tooltipContent = {
            title: title,
            type: 'statement',
          }

          $scope.tooltipObject = {
            position: {left: position.startX, top: position.startY + 20}
          }
        }

        function queueTooltip (position, queue) {
          $scope.clearTooltip();
          $scope.tooltipContent = {
            title: 'Queue',
            type: 'queueDetails',
            queue: queue.info,
          }
          $scope.tooltipObject = {
            position: {left: position.startX - 15, top: position.startY + 20},
            contextMenu: false
          }
        }

        $scope.clearTooltip = function () {
          $scope.tooltipContent = null;
          $scope.tooltipObject = null;
        }

        var MULTI_EDIT_NETWORKS_ON_PRINTQUEUES_listener = $rootScope.$on('MULTI_EDIT_NETWORKS_ON_PRINTQUEUES', (name, data) => {
          $scope.mappedNetworks = data.mappedNetworks;
          const pseudoEvent = {
            clientX: null,
            clientY: null
          }
          $scope.saveChanges(
            $scope.printQueuesPropertiesMulti,
            pseudoEvent,
            { name: 'PrintQueues', dontUseTitle: true },
            { type: 'saveDialog', bypassCloseOutside: true });
        })

        var REFRESH_MULTI_EDIT_PRINTQUEUES_listener = $rootScope.$on('REFRESH_MULTI_EDIT_PRINTQUEUES', () => {
          initMultiEdit();
        });


        $scope.$on('$destroy', function() {
          MULTI_EDIT_NETWORKS_ON_PRINTQUEUES_listener();
          REFRESH_MULTI_EDIT_PRINTQUEUES_listener();
        });


      }
    ]);
})();
